export function canCam({ next, store }) {
  const user = store.state.user;
  const mainRole = store.state.mainRole;

  if (user && typeof user.state !== "undefined" && mainRole && mainRole.team && mainRole.team.name === "cam") {
    return next();
  } else {
    return next("/login");
  }
}
